import voucherUtgLogoUrl from '@assets/print-forms/utg-logo.png'

import { FIELD_BIND_TYPE_ENUM } from '@constants'

import labelCellTpl from '../templates/voucher-debug-box.hbs'
import voucherPrintDoc from '../templates/voucher-print-document.hbs'
import { PrintFormConfig } from '../types'

export const PRINT_FORM_CONFIGS: PrintFormConfig[] = [
  {
    id: 'voucher-labels',
    title: 'Ваучеры / этикетки',
    command: {
      objectCode: 'vou-print-test',
      commandCode: 'object_read_all',
      method: 'GET',
      params: [
        {
          id: null,
          title: 'expands',
          type: FIELD_BIND_TYPE_ENUM.STATIC,
          objectCode: null,
          value: 'flight_ref:expands_flight_ref',
          pathArray: null,
        },
      ],
    },
    layout: {
      paperSize: 'A4',
      orientation: 'landscape',
    },
    templateContext: {
      voucherUtgLogoSrc: voucherUtgLogoUrl,
    },
    documentTemplate: voucherPrintDoc,
    documentPartials: {
      'label-cell': labelCellTpl,
    },
  },
]
